import React from 'react'

// const content = '加载中...'

export function componentUpdateWithToast (Component) {
  return class WrapperComponent extends React.PureComponent {
    componentDidUpdate (prevProps, prevState, snapshot) {
      if (prevProps.loading !== this.props.loading) {
        let { loading, errorMessage } = this.props
        if (loading) {
          // window.toast.hide()
          window.toast.show()
        } else if (errorMessage) {
          window.toast.fail(errorMessage)
        } else {
          window.toast.hide()
        }
      }
    }

    render () {
      return <Component {...this.props} />
    }
  }
}
